import { ref } from 'vue';
import type { ZvdZStandardModel } from '@/types';

export enum LoginPhase {
  login,
  setupTwoFactor,
  verifyTwoFactor,
  twoFactorPolicy,
  verwerkersovereenkomst,
  loggedIn,
  RedirectToOtherPortal,
  username,
}

export const loginPhase = ref<LoginPhase>(LoginPhase.username);

export enum TwoFactorVerificationMethod {
  none = 1,
  email = 2,
  sms = 3,
  app = 4,
}

export type TwoFactorVerificationMethodOption = {
  key?: TwoFactorVerificationMethod;
  value?: string | TwoFactorVerificationMethod;
  text?: string;
  selected?: boolean;
};

export type LoginModel = ZvdZStandardModel & {
  redirectTo: LoginPhase;
  redirectUrl?: string;
  succesvol?: boolean;
  screenWidth?: number;
  screenHeight?: number;
  qrCode?: string;
  emailadres?: string;
  telefoonnummer?: string;
  algemeneVoorwaardenNietAkkoord?: boolean;
  tweeStapsVerificatieMethoden?: TwoFactorVerificationMethodOption[];
  methodeOmTeVerifieren?: TwoFactorVerificationMethod;
  verstuurdeMethode?: TwoFactorVerificationMethod | null;
  verwerkersovereenkomstOrganisatieNaam?: string;
  verwerkersovereenkomstKlantteamTelefoonnummer?: string;
  emailNeedsConfirmation?: boolean;
  phonenumberNeedsConfirmation?: boolean;
  loginMessage?: {
    title: string;
    message: string;
  };
};
